/* eslint-disable */

import './_tire.min'

var token, headerShown, showingLanguageSelector, HomerunElements, Carousel;

/*
 * Sticky header
 */

headerShown = false;

window.onscroll = function () {
    var scroll;
    if (!$('.career-site-header[data-on-scroll="true"]').length && !$('header.job-header').length) {
        return;
    }

    scroll = document.documentElement.scrollTop || document.body.scrollTop;

    if (scroll > 0 && !headerShown) {
        $('.career-site-header[data-on-scroll="true"], header.job-header, .back-to-career-site').addClass('show');
        headerShown = true;
    }

    if (scroll <= 0 && headerShown) {
        $('.career-site-header[data-on-scroll="true"], header.job-header, .back-to-career-site').removeClass('show');
        headerShown = false;
    }
};


/**
 * Language selector
 */

showingLanguageSelector = false;

$('.language-switch').each(function (i, e) {
    $(e).on('click', function (f) {
        f.preventDefault();
        if (showingLanguageSelector) {
            $('.language-switch').removeClass('active');
            showingLanguageSelector = false;
        } else {
            $('.language-switch').addClass('active');
            showingLanguageSelector = true;
        }
    });
});


$('.language-switch a').each(function (i, e) {
    $(e).on('click', function (f) {
        f.stopPropagation();
    });
});





HomerunElements = window.HomerunElements || {};
HomerunElements.StickyNav = {};
HomerunElements.CoverVideo = {};
HomerunElements.VacanciesView = {};
HomerunElements.DailyCulture = {};
HomerunElements.Carousel = {};

/*
 * Apply-button links in private mode
 */

function gup(name, url) {
    var results;
    name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
    results = new RegExp('[?&]' + name + '=?([^&#]*)').exec(url || window.location.href);
    return results === null ? null : results[1] || true;
}

token = gup('token');

if (token) {
    $('a.btn-apply').on('click', function () {
        if (!gup('token', $(this).attr('href'))) {
            window.location = $(this).attr('href') + '?token=' + token;
            return false;
        }
    });
}

/*
 * Move the header content to the left, depending on the Apply Now button width
 */
if (document.querySelectorAll('.header-right').length) {
    setTimeout(function () {
        var button = document.querySelectorAll('.btn-apply')[0];
        if (typeof button !== 'undefined') {
            document.querySelectorAll('.header-right')[0].style.right = button.offsetWidth + 'px';
        }
    }, 200);
}

/*
 * Language selector
 */
window.toggleLanguageMenu = () => {
  $('.language-selector[data-type="share"]').removeClass('active');
  $('.language-selector:not([data-type="share"])').toggleClass('active');
}

/**
 * Share dropdown
 */
const dropdowns = document.querySelectorAll('.js-dropdown');
const links = document.querySelectorAll('a[data-link="openLink"]');

links.forEach((link) => {
    link.addEventListener('keydown', (event) => {
        if (event.key === "Enter" || event.key === "Space") {
                window.open(link.href, '_self');
        }
    })
})

const toggleMenu = (event) => {
  const el = event.currentTarget

  dropdowns.forEach((dropdown) => {
     if (dropdown !== el) {
       dropdown.classList.remove('active')
     }
   });

   // Toggle the clicked dropdown
   el.classList.toggle('active')
}

dropdowns.forEach((dropdown) => {
  dropdown.addEventListener('click', toggleMenu);
  dropdown.addEventListener('keydown', (event) => {
    if (event.key === "Enter" || event.key === "Space") {
      toggleMenu(event)
    }
  })
})


window.toggleShareMenu = () => {
  $('.language-selector:not([data-type="share"])').removeClass('active');
  $('.language-selector[data-type="share"]').toggleClass('active');
}

/*
 * Youtube API helper
 */

window.onYouTubeIframeAPIReady = () => {
    var player = new YT.Player('player', {
        events: {
            'onReady': function (event) {
          event.target.mute();
      }
        }
    });
}

/*
 * Cover video
 */

(function (coverVideo) {

    coverVideo.init = function () {
        var el, url, iframe, frameH, frameW, ratioFrame, ratioFilm, newH, newW, player, tag, firstScriptTag;
        if (typeof $('.cover.module').attr('data-provider') === 'undefined') {
            return;
        };

        el = $('.cover.module').eq(0);

        url = coverVideo.url(
                    el.attr('data-provider'),
                    el.attr('data-id'),
                    el.attr('data-loop') === 'true',
                    true
                  );

        iframe = $('<iframe id="player" src="' + url + '" frameborder="0"></iframe>');

        frameH      = parseInt(el.css('height'), 10);
        frameW      = parseInt(el.css('width'), 10);
        ratioFrame  = frameH / frameW;
        ratioFilm   = 0.5625;
        newH        = 0;
        newW        = 0;

        if (ratioFrame <= ratioFilm) {
            newW  = frameW;
            newH  = Math.ceil(newW * ratioFilm);

            iframe.css({
                width: newW + 'px',
                height: newH + 'px',
                top: '50%',
                margin: parseInt(newH / -2, 10) + 'px 0 0 0',
                left: 0
            });
        } else {
            newH  = frameH;
            newW  = Math.ceil(newH / ratioFilm);

            iframe.css({
                width: newW + 'px',
                height: newH + 'px',
                top: 0,
                left: parseInt(-(newW - frameW) / 2, 10) + 'px'
            });
        }

        el.append(iframe);

        if (el.attr('data-mute') === 'true') {
            if (el.attr('data-provider') === 'vimeo') {
                player = $f(iframe[0]);

                player.addEvent('ready', function () {
                    player.api('setVolume', 0);
                });
            } else if (el.attr('data-provider') === 'youtube') {
                tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }
        }
    };

    coverVideo.url = function (provider, id, loop) {
        var url;

        switch (provider) {
            case 'vimeo':
                url = '//player.vimeo.com/video/' + id + '?title=0&byline=0&portrait=0&badge=0&autoplay=1&api=1';
            break;
            case 'youtube':
                url = 'https://www.youtube.com/embed/' + id + '?modestbranding=1&iv_load_policy=3&rel=0&showinfo=0&theme=light&controls=0&autoplay=1&enablejsapi=1';
            break;
        }

        if (loop) {
            url += '&loop=1';
        }

        return url;
    };

})(HomerunElements.CoverVideo);

HomerunElements.CoverVideo.init();


/*
 * Vacancies advanced view switch buttons
 */

(function (VacanciesView) {

    VacanciesView.init = function () {
        $('.advanced-view-buttons a').on('click', function () {
            $('.advanced-view-buttons a').removeClass('selected');
            $(this).addClass('selected');
            $('.jobs-listing').attr('data-selected-view', $(this).attr('data-view'));
        });
    };

})(HomerunElements.VacanciesView);

HomerunElements.VacanciesView.init();


/*
 * Daily culture
 */

(function (dailyCulture) {

    dailyCulture.init = function () {
        $('.daily-culture').each(function(index){
            var el = $(this);

            if (typeof el.attr('data-token') !== 'undefined' && el.attr('data-token') !== '') {
                setTimeout(function(){
                    dailyCulture.getFeed(
                        el.attr('data-token'),
                        el.attr('data-domain'),
                        function (media) {
                            if (media.length) {
                                el.find('.media-holder').empty();
                            }
                            for (var i = 0; i < media.length; i++) {
                                if (i === 8) {
                                    break;
                                }
                                var newEl = document.createElement('a');
                                newEl.setAttribute('class', 'media media' + i);
                                newEl.setAttribute('target', '_blank');
                                newEl.setAttribute('href', media[i].link);
                                newEl.setAttribute('style', 'background-image: url("' + media[i].image + '");');
                                el.find('.media-holder').append(newEl);
                            }
                        }
                    );
                }, index * 100);
            }
        });
    };

    dailyCulture.getFeed = function (companyToken, domain, callback) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", `https://embed.${domain}/${companyToken}/instagram.json`, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4 && xhr.status === 200) {
                callback(JSON.parse(xhr.responseText));
            }
        };
        xhr.send();
    };

})(HomerunElements.DailyCulture);

HomerunElements.DailyCulture.init();

/*
 * Carousel
 */

Carousel = function (carousel) {
    var currentImage = 0,
      MOBILE_SCALE = 1.6,
      MOBILE_BREAK = 600,
      totalUlWidthPct = parseFloat(carousel.find('ul').attr('data-width')),
      scale = window.innerWidth <= MOBILE_BREAK ? MOBILE_SCALE : 1;

    function translateX() {
        var priorWidth = 0;
        for (var i = 0; i < currentImage; i++) {
            priorWidth += parseFloat(carousel.find('li').eq(i).attr('data-width'));
        }

        var windowWidthPct = (100 / totalUlWidthPct * 100) / scale;

        var curW = parseFloat(carousel.find('li').eq(currentImage).attr('data-width'));
        var x = priorWidth - ((windowWidthPct - curW) / 2);

        var translate = Math.max(Math.min(-x, 0), -1 * (100 - windowWidthPct));

        var transform = 'scale(' + scale + ') translateX(' + translate + '%)';

        carousel.find('ul').css({
            '-webkit-transform': transform,
            '-moz-transform': transform,
            '-ms-transform': transform,
            transform: transform
        });

        carousel.find('.control.prev').toggle(currentImage > 0);
        carousel.find('.control.next').toggle(currentImage < carousel.find('li').length - 1);
    };

    function init() {
        var el;
        if (carousel.find('.control.prev').length === 0) {
            el = carousel.find('.control.next').clone();
            el.removeClass('next').addClass('prev');
            carousel.find('.carousel-container').append(el);
        } else if (carousel.find('.control.next').length === 0) {
            el = carousel.find('.control.prev').clone();
            el.removeClass('prev').addClass('next');
            carousel.find('.carousel-container').append(el);
        }

        carousel.find('.control.prev').on('click', previous);
        carousel.find('.control.next').on('click', next);

        translateX();

        $(window).on('resize', function () {
            var newScale = window.innerWidth <= MOBILE_BREAK ? MOBILE_SCALE : 1;
            if (newScale !== scale) {
                scale = newScale;
                translateX();
            }
        });
    };

    function next() {
        if (currentImage < carousel.find('li').length - 1) {
            currentImage++;
        }
        translateX();
    };

    function previous() {
        if (currentImage > 0) {
            currentImage--;
        }
        translateX();
    };

    init();
};

$('.workplace').each(function () {
    Carousel($(this));
});

// On click 'see all jobs' button on career page, scrolls down to the job list.
$('.btn-all-jobs').on('click', function (e) {
    e.preventDefault();

    const target = document.getElementById('job-list');

    if (target) {
        target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
});

function initGoogleMaps() {
    var el = document.querySelector('meta[name="google-maps-key"]');
    var key = el !== null ? el.getAttribute('content') : '';

    if ($('.google-map').length) {
        var script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + key + '&callback=renderGoogleMaps';
        document.body.appendChild(script);
    }
}

function renderGoogleMaps() {
    $('.google-map').each(function() {
        var el = $(this).get(0);

        var location = JSON.parse(el.getAttribute('data-center'));

        var showControls = window.innerWidth > 640;

        var myOptions = {
            zoom: 14,
            center: location,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: !showControls,
            disableDoubleClickZoom: !showControls,
            draggable: showControls,
            scrollwheel: false
        };

        var map = new google.maps.Map(el, myOptions);

        var marker = new google.maps.Marker({
            map: map,
            position: location
        });
    });
}

// see https://github.com/homerunco/Homerun/issues/167
window.renderGoogleMaps = renderGoogleMaps

initGoogleMaps();


/*
 * Cover size
 * Todo: replace this with css vh units (note: vh does'nt work right on iOS7)
 */

function setCoverSize() {
    var cover, el, size;
    if (window.innerHeight - document.body.offsetHeight > 0) {
        el = document.querySelectorAll('.vacancies.module');
        if (el.length) {
            el[0].style.height = el[0].offsetHeight + (window.innerHeight - document.body.offsetHeight) + 'px';
        }
    }

    cover = document.querySelectorAll('.cover.module');

    if (!cover.length) {
        return;
    };
    if (cover[0].className.match(/\bimage\b/)) {
        return;
    }; // case: career site, image with cover mode

    size = cover[0].className.match(/\bfull\b/) ? 1 : 0.5;
    cover[0].style.height = (window.innerHeight * size) + 'px';
}

setCoverSize();

window.onresize = setCoverSize;
